const KEY = "devisto_consent";
const VERSION = 1;

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && c.version === VERSION ? c : null;
  } catch { return null; }
};

export const saveConsent = ({ comfort, country, lang }) => {
  localStorage.setItem(KEY, JSON.stringify({ version: VERSION, essential: true, comfort: !!comfort, country, lang, at: new Date().toISOString() }));
  if (!comfort) localStorage.removeItem("devisto_device");
};

export const comfortAllowed = () => readConsent()?.comfort !== false;
